import { DefaultService } from '@/services/DefaultService';

export default class ProContratoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(contrato) {
        return this._http.post(`${this._env}/promotor/contrato`, contrato, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/contrato/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findByLpsId(id, page = 0, limit = 50, ids, sort, ...param) {
        return this._http
            .post(
                `${this._env}/promotor/contrato/lps/${id}.json?page=${page}&limit=${limit}&column=${
                    sort.column
                }&order=${sort.order}&param=${param}`,
                ids,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllByCliente(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/contrato/bycliente.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAll(page = 0, limit = 50, sort, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/promotor/contrato.json?page=${page}&limit=${limit}&column=${
                        sort.column
                    }&order=${sort.order}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/contrato/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    updateSituacao(obj) {
        return this._http
            .post(`${this._env}/promotor/contrato/updatesituacao`, obj, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/contrato/getcombo.json?situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllGroupByAtendomento(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/contrato/group-by-atendimento.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
